<template>
  <van-list
    v-model:loading="recommendLoading"
    :finished="recommendFinished"
    loading-text="loading..."
    :immediate-check="false"
    :offset="300"
    @load="getRecommendedFn"
  >
    <KProductList :product-list="recommendProduct" />
  </van-list>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { getRecommended } from '@/api/models/home'
import { buildAccountRecommendSource, buildCartRecommendSource, buildHomeRecommendSource, buildPayResultRecommendSource, buildProductDetailRecommendSource } from '@/plugins/utils'

const props = withDefaults(
  defineProps<{ 
    recommendId: number,
    skuIds?: number[],
    clsId?: number,
    listingIds?: number[]
  }>(),
  {
    skuIds: () => ([])
  }
)

const emits = defineEmits<{
  (e: 'loaded', isEmpty: boolean): void
}>()
/** 推荐数据 */
const recommendProduct = ref([])
const recommendLoading = ref(false)
const recommendFinished = ref(false)

const getSource = (modeName: string): string => {
  let so: string = ''
  // 购物车
  if(props.recommendId === 5){
    so = buildCartRecommendSource(modeName)
  } else if(props.recommendId === 1) {
    so = buildHomeRecommendSource(modeName)
  } else if(props.recommendId === 8) {
    so = buildAccountRecommendSource(modeName)
  } else if(props.recommendId === 4) {
    so = buildProductDetailRecommendSource(modeName)
  } else if(props.recommendId === 6) {
    so = buildPayResultRecommendSource(modeName)
  }

  return so
}

const page = ref(0)
const getRecommendedFn = async () => {
  const params: IPayload = {
    skip: page.value * 20,
    limit: 20
  }
  const excludeListings: number[] = props.listingIds?.length ? props.listingIds : []
  const res = await getRecommended(props.recommendId, params, props.skuIds, props.clsId, excludeListings)
  if(res && res.code === 0) {
    if(res.data.listings.length) {
      const _list = res.data.listings.map((c: any) => {
        const _so = getSource(c.modelName || c.algorithmModelName || '')
        _so && (c.source = _so)

        return c
      })
      recommendProduct.value = recommendProduct.value.concat(_list)
      page.value += 1
      recommendLoading.value = false
    } else {
      recommendFinished.value = true
    }

    emits('loaded', res.data.listings?.length <= 0)
  } else {
    recommendFinished.value = true
  }
}

await getRecommendedFn()
</script>
<style lang='scss' scoped>
</style>